import { useLocation } from "react-router-dom";
import { categories, comics } from "@/mocks/comics";
import { Link } from "react-router-dom";

export default function Breadcrumb() {
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);

  if (pathParts.length === 0) return null;

  const items: { name: string; href: string }[] = [
    { name: "首页", href: "/" },
  ];

  if (pathParts[0] === "category" && pathParts[1]) {
    const cat = categories.find((c) => c.slug === pathParts[1]);
    items.push({
      name: cat ? cat.name : pathParts[1],
      href: `/category/${pathParts[1]}`,
    });
  }

  if (pathParts[0] === "article" && pathParts[1]) {
    const comic = comics.find((c) => c.id === Number(pathParts[1]));
    items.push({
      name: comic ? comic.title : "文章",
      href: `/article/${pathParts[1]}`,
    });
  }

  if (pathParts[0] === "about") {
    items.push({ name: "关于我们", href: "/about" });
  }

  return (
    <nav aria-label="面包屑导航" className="max-w-7xl mx-auto px-4 md:px-6 py-3">
      <ol className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
        {items.map((item, idx) => (
          <li key={item.href} className="flex items-center gap-1.5">
            {idx > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
            )}
            {idx < items.length - 1 ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-600 no-underline transition-colors"
              >
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}